// Tiny client-side A/B experiment + analytics tracker.
// Stores the chosen variant in localStorage so a user always sees the same
// experience across reloads. Fires a fire-and-forget POST to /api/events.

import api from "./api";

const VARIANT_KEY = (name) => `tiplingo_exp_${name}_v1`;
const IMPRESSED_KEY = (name) => `tiplingo_exp_${name}_impr_v1`;

function safeGet(key) {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}

function safeSet(key, value) {
  try {
    localStorage.setItem(key, value);
  } catch {
    /* storage disabled — variant resets next reload, acceptable */
  }
}

/**
 * Pick a sticky variant for the given experiment.
 * @param {string} name — experiment id e.g. "paywall_v1"
 * @param {string[]} variants — e.g. ["A","B"]
 * @returns chosen variant string
 */
export function getVariant(name, variants = ["A", "B"]) {
  const existing = safeGet(VARIANT_KEY(name));
  if (existing && variants.includes(existing)) return existing;
  const pick = variants[Math.floor(Math.random() * variants.length)];
  safeSet(VARIANT_KEY(name), pick);
  return pick;
}

/**
 * Fire a single analytics event. Best-effort — never throws.
 */
export function track(name, props = {}, variant = null) {
  try {
    api
      .post("/events", { name, variant, props })
      .catch(() => {
        /* analytics failures are silent */
      });
  } catch {
    /* nothing */
  }
}

/**
 * Track a single impression per experiment (once per browser, sticky).
 * Safe to call on every render — only fires the first time.
 */
export function trackImpressionOnce(name, variant, props = {}) {
  const k = IMPRESSED_KEY(name);
  if (safeGet(k)) return;
  safeSet(k, "1");
  track(`${name}_impression`, props, variant);
}
